import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { BlackbaudRaisersEdgeIntegration, IBlackbaudFund } from '@feathr/blackbox';
import { toast } from '@feathr/components';

interface IUseGetBBFundsReturn {
  funds: IBlackbaudFund[];
  isLoading: boolean;
}

function useGetBBFunds(integration: BlackbaudRaisersEdgeIntegration): IUseGetBBFundsReturn {
  const { t } = useTranslation();
  const [funds, setFunds] = useState<IBlackbaudFund[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadFunds(): Promise<void> {
      setIsLoading(true);
      try {
        const response = await integration.getFunds();
        setFunds(response?.funds ?? []);
      } catch (error) {
        toast(
          t('Failed to load funds:\n{{error}}', {
            error: (error as Error).message,
          }),
          { type: 'error' },
        );
        // eslint-disable-next-line no-console
        console.error('Failed to load funds', error);
      } finally {
        setIsLoading(false);
      }
    }

    loadFunds();
  }, [integration.id, t]);

  return { funds, isLoading };
}

export default useGetBBFunds;
